import { Card, Button, ICard, QuickReply } from './card';
import { Product } from './product';
import { downloadAttachments, Attachments } from './downloadAttachments';
import { Webviews } from './webviews';
import { Message, IMessage } from './message';

const message = new Message();
const card = new Card();
const product = new Product();
const attachments = new Attachments();
const webviews = new Webviews();

export {
  message,
  IMessage,
  card,
  ICard,
  Button,
  product,
  QuickReply,
  downloadAttachments,
  attachments,
  webviews
};